module.exports = __webpack_public_path__ + "img/9791185072364.da657d89.jpg";